import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Paths } from 'routes';
import { useIsMounted } from 'hooks';
import { PdfLoader, PdfViewer } from 'components/partials';
import { getTermsAndConditions } from 'redux/root.actions';
import { ILanguage, TRANSLATIONS_VALUES_KEYS } from 'redux/internationalization/internationalization';
import { selectInternationalizationStateIsLoading, selectSelectedLanguage, selectTermsAndConditions } from 'redux/root.selectors';
import { useTranslate } from 'services';

const { terms_of_service } = TRANSLATIONS_VALUES_KEYS;

function TermsAndConditionsPdf() {
  const history = useHistory();
  const isMounted = useIsMounted();
  const dispatch = useDispatch();

  const selectedLanguage = useSelector<string, ILanguage>(selectSelectedLanguage);

  const termsAndConditions = useSelector<string, string>(selectTermsAndConditions);
  const isLoading = useSelector<string, boolean>(selectInternationalizationStateIsLoading);
  const { translateToString } = useTranslate();

  useEffect(() => {
    if (isMounted && selectedLanguage?.id) {
      dispatch(getTermsAndConditions(selectedLanguage?.id));
    }
  }, [dispatch, isMounted, selectedLanguage]);

  if (isLoading && !termsAndConditions) {
    return (<PdfLoader />);
  }

  return (<PdfViewer
    documentFile={termsAndConditions}
    errorMsg={translateToString(terms_of_service.failed_load)}
    onCancelClick={() => { history.push(Paths.startScanning); }}
  />);
}

export default TermsAndConditionsPdf;
